/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState, useContext} from 'react';
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/database";
import 'firebase/compat/analytics';
import {
  Switch,
  Route,
  Link,
  useParams,
  useRouteMatch,
} from "react-router-dom";
import i18next from 'i18next';
import {init} from '../utils/initFirebase'
import cards from '../assets/cards.json';
import DiceHistorical from '../components/DiceHistorical';
import DiceRoll from '../components/DiceRoll';
import Inventory from '../components/Inventory';
import UserContext from '../context/UserContext';
import CharacterContext from '../context/CharacterContext';
import CampaignContext from '../context/CampaignContext';
import '../styles/character.css';
import '../styles/conditions.css';
import '../styles/modal.css';
import DiceChat from './DiceChat';
import EditCharacter from './EditCharacter';
import MobileInventory from './MobileInventory';
import {
  PencilAltIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  AnnotationIcon,
  UserIcon,
  MapIcon,
  UsersIcon,
  BeakerIcon,
  SparklesIcon,
  ShareIcon,
  GlobeAltIcon,
  ChatIcon,
} from '@heroicons/react/outline';
import {dynamicSortWithTraduction} from '../utils/sort';
import {getRoll, getMagicCard, generateUpdateHisto, getRandomValue} from '../utils/dice';
import { useDiceAnimSetting } from '../hooks/useDiceAnimSetting';
import { useDiceColorSetting } from '../hooks/useDiceColorSetting';
import { useHideChatSetting } from '../hooks/useHideChatSetting';
import { useRollToasts } from '../hooks/useRollToasts';
import DiceAnimationOverlay, { ANIM_TOTAL_MS } from '../components/DiceAnimationOverlay';
import {
  BrowserView,
  MobileView,
  isMobile
} from "react-device-detect";
import { toast } from 'react-toastify';
import Picture from '../components/Picture';
import Skills from '../components/Skills';
import Characteristics from '../components/Characteristics';
import Company from '../components/Company';
import {getLabelDice} from '../utils/dice'
import Alchemy from '../components/Alchemy';
import Curency from '../components/Curency';
import Hp from '../components/Hp';
import MagicCard from '../components/MagicCard';
import MagicCardResume from '../components/MagicCardResume';
import DeathMagic from '../components/DeathMagic';
import ImagePanel, {ImmersiveImageOverlay} from '../components/ImagePanel';
import AmbianceWidget from '../components/AmbianceWidget';
import CampaignNotes from '../components/CampaignNotes';
import ConditionBadges from '../components/ConditionBadges';
import CONDITIONS from '../assets/conditions';
import TimerWidget from '../components/TimerWidget';
import CampaignMap from '../components/CampaignMap';
import CampaignLibrary from '../components/CampaignLibrary';

init();
const db = firebase.firestore();

const Character = (props) => {
  let match = useRouteMatch();
  const {user, updateUser} = useContext(UserContext);
  const {campaign} = useContext(CampaignContext);
  const {character, updateCharacter} = useContext(CharacterContext);
  let { characterIdUrl } = useParams();
  const [defaultDataCharacter, setDefaultDataCharacter] = useState({});
  const [descriptionIsDisplay, setDescriptionIsDisplay] = useState(false)
  const [rollList, setRollList] = useState([]);
  const [characteristics,setCharacteristics] = useState([]);
  const [skills,setSkills] = useState([]);
  const [hideRollSwitch,setHideRollSwitch] = useState(false);
  const [view,setView] = useState('character');
  const [company, setCompany] = useState([]);
  const [saveStatus, setSaveStatus] = useState(null);
  const [diceAnim, setDiceAnim] = useState(null);
  const [conditionMenuOpen, setConditionMenuOpen] = useState(false);
  const conditionMenuRef = React.useRef(null);
  const [spectatorAnim, setSpectatorAnim] = useState(null);
  const [animEnabled, toggleAnim] = useDiceAnimSetting();
  const [diceColor] = useDiceColorSetting();
  const [hideChat, setHideChat] = useHideChatSetting();
  useRollToasts(rollList, hideChat, campaign, user);

  const broadcastDiceAnim = (diceType, value) => {
    firebase.database().ref(`diceAnim/${campaign.uid}`).set({ diceType, value, userUid: user.uid, rolledAt: Date.now() });
    setTimeout(() => firebase.database().ref(`diceAnim/${campaign.uid}`).remove(), 8000);
  };

  const handleSetNewDice = (valMaxRoll, stat = null, type = null, quantity = 1) => {
    if (quantity > 1) {
      const rolls = Array.from({ length: quantity }, () => getRandomValue(valMaxRoll));
      const total = rolls.reduce((a, b) => a + b, 0);
      sendNewRoll(getRoll(valMaxRoll, campaign.idUserDm, character, user, stat, hideRollSwitch, type, total, quantity, rolls));
    } else {
      const value = getRandomValue(valMaxRoll);
      broadcastDiceAnim(valMaxRoll, value);
      if (animEnabled) {
        setDiceAnim({ diceType: valMaxRoll, value, stat, type });
      } else {
        setTimeout(() => sendNewRoll(getRoll(valMaxRoll, campaign.idUserDm, character, user, stat, hideRollSwitch, type, value)), ANIM_TOTAL_MS);
      }
    }
  };

  useEffect(() => {
    if(user.uid && characterIdUrl !== 'dm') {
      getCharacter();
    }
  }, []);
 
  useEffect(() => {
    if(campaign.uid) {
      const unsubCompany = getCharactersCompany(campaign);
      const dbRefObject = firebase.database().ref().child(`${campaign.uid}`);
      dbRefObject.on('value', snap => {
        setRollList(Object.values(snap.val() || {}));
      });
      const animRef = firebase.database().ref(`diceAnim/${campaign.uid}`);
      animRef.on('value', snap => {
        const data = snap.val();
        if (!data) return;
        if (data.userUid === user.uid) return;
        if (Date.now() - data.rolledAt > 10000) return;
        setSpectatorAnim({ diceType: data.diceType, value: data.value });
      });
      return () => { dbRefObject.off(); animRef.off(); if(unsubCompany) unsubCompany(); };
    }
  }, [campaign]);

  useEffect(() => {
    if(character && character.uid) {
      setSkills(character.skills);
      setDefaultDataCharacter(JSON.parse(JSON.stringify(character)));
      if(character.characteristics) {
        setCharacteristics(character.characteristics.sort(dynamicSortWithTraduction("label", 'characteristics')));
      }
    }
  },[character])

  const getCharacter = async () => {
    await db.collection('characters').doc((character && character.uid) || characterIdUrl).get()
      .then(doc => {
        updateCharacter({
          ...doc.data(),
        });
        setDefaultDataCharacter(doc.data());
        setCharacteristics(doc.data().characteristics.sort(dynamicSortWithTraduction("label", 'characteristics')));
        setSkills(doc.data().skills.sort(dynamicSortWithTraduction("label", 'skills')));

    })
    .catch(err => {
      console.log(err)
    })
  }

  const REACTION_EMOJIS = ['🎉', '💀', '😬'];

  const handleReact = (rollIdx, emoji) => {
    const updated = rollList.map((r, i) => {
      if (i !== rollIdx) return r;
      const reactions = { ...r.reactions };
      REACTION_EMOJIS.forEach(e => {
        reactions[e] = (reactions[e] || []).filter(uid => uid !== user.uid);
      });
      const hadIt = (r.reactions?.[emoji] || []).includes(user.uid);
      if (!hadIt) reactions[emoji] = [...(reactions[emoji] || []), user.uid];
      return { ...r, reactions };
    });
    firebase.database().ref().child(`${character.idCampaign}`).set(updated);
  };

  const sendNewRoll = async (newRoll) => {
    let newList = [
      ...rollList
    ];
    if(Array.isArray(newRoll)) {
      newList = [
        ...newList,
        ...newRoll
      ]
    } else if(newRoll) {
      newList.push(newRoll);
    }
    
    firebase.database().ref().child(`${character.idCampaign}`).set(newList);
    const roll = Array.isArray(newRoll) ? newRoll[0] : newRoll;
    if(!roll) return;
    if(isMobile) {
      toast.success(`${getLabelDice(roll, campaign, user)} : ${roll.value}`, {});
    }
    firebase.analytics().setUserId(user.uid);
    firebase.analytics().setUserProperties({
      name: user.displayName,
      uid: user.uid,
      campaign: campaign.uid,
    });
    if(roll.diceType === 100) {
      if(roll.value === 100) {
        await unlockFrame('100');
      }
      if(roll.value === 1) {
        await unlockFrame('1');
      }
    }

    const labelStat = roll.stat ? roll.stat.label : 'Custom'
    firebase.analytics().logEvent('Roll', {
      campaign: campaign.uid,
      type: roll.diceType,
      stat: labelStat,
      result: roll.value
    });
  }

  const updateFirestoreCharacter = async (newData) => {
    setSaveStatus('saving');
    newData.lastUpdateAt = firebase.firestore.FieldValue.serverTimestamp();
    await db.collection('characters').doc(newData.uid).set(newData).then(res => {
      setSaveStatus('saved');
      setTimeout(() => setSaveStatus(null), 2000);
      firebase.analytics().setUserId(user.uid);
      firebase.analytics().setUserProperties({
        name: user.displayName,
        campaign: campaign.uid,
      });
      firebase.analytics().logEvent('updateCharacter', {
        characterUpdated: character.uid
      });
    }).catch(e => {
      setSaveStatus(null);
      console.log(e)
    });
  }

  const getCharactersCompany = (currentCampaign) => {
    try {
      return db.collection('characters').where('idCampaign', '==', currentCampaign.uid).where('active', '==', true).where('idUser', '!=', currentCampaign.idUserDm)
        .onSnapshot(querySnapshot => {
          const listCharactersGroup = [];
          querySnapshot.forEach(doc => {
            const data = doc.data();
            if (!data.isNpc) {
              listCharactersGroup.push(data)
            }
          });
          setCompany(listCharactersGroup);
        }, err => {
          console.log(err.message)
        })
    } catch (error) {
      console.log(error);
    }
  }

  const unlockFrame = async (newItemUnlock) => {
    let newUser = user
    if(!newUser.frameUnlock.includes(newItemUnlock)) {
      newUser.frameUnlock.push(newItemUnlock);
      updateUser(newUser);
      await db.collection("users").doc(user.uid).set({
        ...newUser
      }); 
      toast.warning(i18next.t('new frame unlock'), {});
    }
  }
  
  useEffect(() => {
    if (!conditionMenuOpen) return;
    const handleClickOutside = (e) => {
      if (conditionMenuRef.current && !conditionMenuRef.current.contains(e.target)) {
        setConditionMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [conditionMenuOpen]);

  const toggleCondition = (key) => {
    const conditions = character.conditions || [];
    const updated = { ...character, conditions: conditions.includes(key) ? conditions.filter(k => k !== key) : [...conditions, key] };
    updateCharacter(updated);
    updateFirestoreCharacter(updated);
  }

  const updateHp = async(newHp) => {
    const newValHp = parseInt(newHp,10);
    const updatedCharacter = {...character}
    if(newValHp !== updatedCharacter.currentHp) {
      if(newValHp === 0) {
        await unlockFrame('deathGod');
      }
      updatedCharacter.currentHp = newValHp;
      sendNewRoll(generateUpdateHisto(updatedCharacter, defaultDataCharacter,campaign,user,hideRollSwitch))
      updateCharacter(updatedCharacter);
      updateFirestoreCharacter(updatedCharacter);
    }
  }

  const renameValidation = (newName) => {
    const updatedCharacter = {...character}
    if(campaign.renameCharacter && newName !== updatedCharacter.name) {
      updatedCharacter.name = newName;
      updateFirestoreCharacter(updatedCharacter);
    }
  }

  const createPotion = (receipt) => {
      const statLaunch = {
        isCustom: false,
        label: 'createPotion',
        value: parseInt(receipt.difficulty, 10)
      }
      let updates = [];
      let newRoll = getRoll(100,campaign.idUserDm, character, user, statLaunch, hideRollSwitch, "alchemy");
      if(newRoll.value <= receipt.difficulty) {
        const updatedCharacter = {...character};
        const findPotion = updatedCharacter.inventory.find(potion => potion.name === receipt.name && potion.type === 'alchemy')
        if(findPotion) {
          findPotion.number += 1;
        } else {
          updatedCharacter.inventory.push({
            "name": receipt.name,
            "number": 1,
            "default": receipt.default,
            "type": "alchemy"
          })
        }
        updatedCharacter.inventory.find((item) => item.name === 'bottle' && item.default).number -= 1;
        updates = generateUpdateHisto(updatedCharacter, defaultDataCharacter,campaign,user,hideRollSwitch);
        updateCharacter({...updatedCharacter})
        updateFirestoreCharacter(updatedCharacter);
      }
      sendNewRoll([newRoll, ...updates]);
  }

  const updateCurency = (type, value) => {
    const updatedCharacter = {...character}
    if(updatedCharacter.currency) {
      if(updatedCharacter.currency[type] !== value) {
        updatedCharacter.currency[type] = value;
        sendNewRoll(generateUpdateHisto(character, defaultDataCharacter,campaign,user,hideRollSwitch))
        updateCharacter(updatedCharacter);
        updateFirestoreCharacter(updatedCharacter);
      }
    } else {
      updatedCharacter.currency = {
        gold: 0,
        silver: 0,
        bronze: 0,
      }
      sendNewRoll(generateUpdateHisto(character, defaultDataCharacter,campaign,user,hideRollSwitch))
      updatedCharacter.currency[type] = value;
      updateCharacter(updatedCharacter);
      updateFirestoreCharacter(updatedCharacter);
    }
  }

  const rollDiceDeathMagic = (skill) => {
    const newRoll = getRoll(100,campaign.idUserDm, character, user, skill, hideRollSwitch, 'skills');
    if(newRoll.value <= skill.value || skill.value <= 10) {
      character.skills.find(skill => skill.label === 'deathMagic' && skill.isCustom === false).value = 0;
    } else {
      character.skills.find(skill => skill.label === 'deathMagic' && skill.isCustom === false).value -= 10;
    }
    sendNewRoll([newRoll, ...generateUpdateHisto(character, defaultDataCharacter,campaign,user,hideRollSwitch)]);
    updateCharacter({
      ...character,
    });
    updateFirestoreCharacter(character);
  }

  if(character) {
    return (
      <>
      <Switch>
        <Route path={`${match.url}/chat`}>
          <DiceChat
            list={rollList}
            setNewDice={(valMaxRoll, qty) => handleSetNewDice(valMaxRoll, null, null, qty)}
            hideRollSwitch={hideRollSwitch}
            setHideRoll={(val) => { setHideRollSwitch(val) }}
            onReact={handleReact}
          />
        </Route>
        <Route path={`${match.url}/edit`}>
          <EditCharacter
            updateDataCharacter={(characterUpdated, newRollForUpdate) => {
              updateCharacter({
                ...characterUpdated,
              });
              updateFirestoreCharacter(characterUpdated);
              sendNewRoll(newRollForUpdate);
            }}
          />
        </Route>
        <Route path={`${match.url}/inventory`}>
          <MobileInventory
            updateInventory={(characterWithNewInventory) => {
              updateCharacter({
                ...characterWithNewInventory,
              });
              updateFirestoreCharacter(characterWithNewInventory);
            }}
          />
        </Route>
        <Route path={match.path}>
          <div className='containerCharacterView'>
            {campaign.uid && <TimerWidget campaignUid={campaign.uid} isDm={false} />}
            {campaign.uid && character.uid && (
              <ImmersiveImageOverlay campaignUid={campaign.uid} characterUid={character.uid} />
            )}
            {campaign.uid && <AmbianceWidget campaignUid={campaign.uid} isDm={false} />}
            {saveStatus && (
              <div className={`saveIndicator ${saveStatus}`}>
                {saveStatus === 'saving' ? i18next.t('saving') : i18next.t('saved')}
              </div>
            )}
            {diceAnim && (
              <DiceAnimationOverlay
                diceType={diceAnim.diceType}
                finalValue={diceAnim.value}
                diceColor={diceColor}
                onClose={() => {
                  sendNewRoll(getRoll(diceAnim.diceType, campaign.idUserDm, character, user, diceAnim.stat, hideRollSwitch, diceAnim.type, diceAnim.value));
                  setDiceAnim(null);
                }}
              />
            )}
            {spectatorAnim && !diceAnim && animEnabled && (
              <DiceAnimationOverlay
                diceType={spectatorAnim.diceType}
                finalValue={spectatorAnim.value}
                diceColor={diceColor}
                onClose={() => setSpectatorAnim(null)}
              />
            )}
            {(character.idUser === user.uid || campaign.idUserDm === user.uid) && (
              <div className={`characterContainer${(view === 'map' || view === 'library') ? ' characterContainerFull' : ''}${hideChat ? ' chatHidden' : ''}`}>
                <BrowserView className='tabsDetails'>
                  <ul className='tabsContainer'>
                    <li
                      className={`tab ${view === 'character' ? 'active' : ''}`}
                      onClick={() => {
                        setView('character');
                      }}  
                    >
                      {character.name}
                    </li>
                    <li
                      className={`tab ${view === 'inventory' ? 'active' : ''}`}
                      onClick={() => {
                        setView('inventory');
                      }}  
                    >
                      {i18next.t('inventory')}
                    </li>
                    <li
                      className={`tab ${view === 'imagePanel' ? 'active' : ''}`}
                      onClick={() => {
                        setView('imagePanel');
                      }}  
                    >
                      {i18next.t('illustration.title')}
                    </li>
                    <li
                      className={`tab ${view === 'map' ? 'active' : ''}`}
                      onClick={() => setView('map')}
                    >
                      {i18next.t('map.title')}
                    </li>
                    <li
                      className={`tab ${view === 'library' ? 'active' : ''}`}
                      onClick={() => setView('library')}
                    >
                      {i18next.t('library.title')}
                    </li>
                    {character.isAlchemist && (
                      <li
                        className={`tab ${view === 'alchemy' ? 'active' : ''}`}
                        onClick={() => {
                          setView('alchemy');
                        }}  
                      >
                        {i18next.t('alchemy.title')}
                      </li>
                    )}
                    {character.isMage && campaign.playerCanSeeAllCards && (
                      <li
                        className={`tab ${view === 'magic' ? 'active' : ''}`}
                        onClick={() => {
                          setView('magic');
                        }}  
                      >
                        {i18next.t('mage.title')}
                      </li>
                    )}
                    {character.isDeathMage && (
                      <li
                        className={`tab ${view === 'deathMagic' ? 'active' : ''}`}
                        onClick={() => {
                          setView('deathMagic');
                        }}  
                      >
                        {i18next.t('deathMagic.title')}
                      </li>
                    )}
                    <li
                      className={`tab ${view === 'company' ? 'active' : ''}`}
                      onClick={() => {
                        setView('company');
                      }}  
                    >
                      {i18next.t('company')}
                    </li>
                  </ul>
                </BrowserView>
                <MobileView className='tabsDetailsMobile'>
                  <ul className='mobileTabsContainer'>
                    <li
                      className={`tab ${view === 'character' ? 'active' : ''}`}
                      onClick={() => {
                        setView('character');
                      }}  
                    >
                      <UserIcon className='iconTabMobile' />
                    </li>
                    { rollList.length > 0 && (
                      <li
                        className={`tab ${view === 'diceHisto' ? 'active' : ''}`}
                        onClick={() => {
                          setView('diceHisto');
                        }}  
                      >
                        <AnnotationIcon className='iconTabMobile' />
                      </li>
                    )}
                    <li
                      className={`tab ${view === 'inventory' ? 'active' : ''}`}
                      onClick={() => {
                        setView('inventory');
                      }}
                    >
                      <MapIcon className='iconTabMobile' />
                    </li>
                    <li
                      className={`tab ${view === 'map' ? 'active' : ''}`}
                      onClick={() => setView('map')}
                    >
                      <GlobeAltIcon className='iconTabMobile' />
                    </li>
                    {character.isAlchemist && (
                      <li
                        className={`tab ${view === 'alchemy' ? 'active' : ''}`}
                        onClick={() => {
                          setView('alchemy');
                        }}  
                      >
                        <BeakerIcon className='iconTabMobile' />
                      </li>
                    )}
                    {character.isMage && campaign.playerCanSeeAllCards && (
                      <li
                        className={`tab ${view === 'magic' ? 'active' : ''}`}
                        onClick={() => {
                          setView('magic');
                        }}  
                      >
                        <SparklesIcon className='iconTabMobile' />
                      </li>
                    )}
                    <li
                      className={`tab ${view === 'company' ? 'active' : ''}`}
                      onClick={() => {
                        setView('company');
                      }}  
                    >
                      <UsersIcon className='iconTabMobile' />
                    </li>
                  </ul>
                </MobileView>
                {view === 'character' && (
                  <div className='containerInfo'>
                    <div className='nameCharacteristics'>
                      <div className='charHero'>
                        <div className='charHeroInner'>
                        {character.picture
                          ? <img src={character.picture} alt={character.name} className='charHeroImg' style={{ objectPosition: `center ${{ top: '20%', center: '50%', bottom: '80%' }[character.picturePosition || 'center']}` }} />
                          : <div className='charHeroPlaceholder' />
                        }
                        {character.picture && (
                          <div className="dmCharPanelPosButtons">
                            {['top', 'center', 'bottom'].map(pos => (
                              <button
                                key={pos}
                                className={`dmCharPanelPosBtn${(character.picturePosition || 'center') === pos ? ' active' : ''}`}
                                onClick={() => {
                                  const updated = { ...character, picturePosition: pos };
                                  updateCharacter(updated);
                                  updateFirestoreCharacter(updated);
                                }}
                              >
                                {pos === 'top' ? '▲' : pos === 'center' ? '●' : '▼'}
                              </button>
                            ))}
                          </div>
                        )}
                        <div className='charHeroOverlay'>
                          <div className='charHeroIdentity'>
                            <span
                              className='charHeroName'
                              onBlur={(e) => renameValidation(e.currentTarget.textContent)}
                              contentEditable={campaign.renameCharacter}
                            >
                              {character.name}
                            </span>
                            <div className='charHeroHp'>
                              <Hp inline character={character} updateValue={(valHp) => updateHp(valHp)} />
                            </div>
                          </div>
                          <div className='charHeroActions'>
                            <Link className='charHeroEdit' to={`${match.url}/edit`}>
                              <PencilAltIcon style={{ width: 18, height: 18 }} />
                            </Link>
                            <button
                              className='charHeroEdit charHeroShare'
                              type="button"
                              title="Voir la fiche de partage"
                              onClick={() => {
                                const url = `${window.location.origin}/share/${character.uid || characterIdUrl}`;
                                window.open(url, '_blank');
                              }}
                            >
                              <ShareIcon style={{ width: 18, height: 18 }} />
                            </button>
                          </div>
                        </div>
                        <div
                          className='charHeroHpBar'
                          style={{
                            width: `${Math.min((character.currentHp * 100) / character.maxHp, 100)}%`,
                            background: (character.currentHp / character.maxHp) < 0.3 ? '#e53935' : 'var(--main-yellow, #ffad23)',
                          }}
                        />
                        </div>
                        <div className={`conditionRadialMenu${conditionMenuOpen ? ' open' : ''}`} ref={conditionMenuRef}>
                          <button className='conditionRadialTrigger' type="button" onClick={() => setConditionMenuOpen(v => !v)}>
                            {(character.conditions || []).length > 0
                              ? <span>{CONDITIONS.find(c => c.key === character.conditions[0])?.emoji}</span>
                              : <span className='conditionRadialIcon'>✦</span>
                            }
                          </button>
                          <div className='conditionRadialItems'>
                            {CONDITIONS.map((c, idx) => {
                              const active = (character.conditions || []).includes(c.key);
                              const total = CONDITIONS.length;
                              const angle = -90 + (idx / total) * 360;
                              const rad = angle * (Math.PI / 180);
                              const r = 65;
                              const x = Math.round(Math.cos(rad) * r);
                              const y = Math.round(Math.sin(rad) * r);
                              const tooltipOffset = 36;
                              const ttx = Math.round((x / r) * tooltipOffset);
                              const tty = Math.round((y / r) * tooltipOffset);
                              return (
                                <button
                                  key={c.key}
                                  type="button"
                                  className={`conditionRadialItem${active ? ' active' : ''}`}
                                  style={{ '--tx': `${x}px`, '--ty': `${y}px`, '--ttx': `${ttx}px`, '--tty': `${tty}px` }}
                                  title={c.label}
                                  onClick={() => toggleCondition(c.key)}
                                >
                                  {c.emoji}
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                      <div className='altOptionContainer'>
                        <div>
                          <Curency type='gold' max={9999} min={0}
                            value={character.currency?.gold || 0}
                            updateValue={(v) => updateCurency('gold', v)} />
                          <Curency type='silver' max={9999} min={0}
                            value={character.currency?.silver || 0}
                            updateValue={(v) => updateCurency('silver', v)} />
                          <Curency type='bronze' max={9999} min={0}
                            value={character.currency?.bronze || 0}
                            updateValue={(v) => updateCurency('bronze', v)} />
                        </div>
                        {character.isMage && (
                          <MagicCard
                            magicCards={character.magicCards}
                            drawCard={() => {
                              const data = getMagicCard(character, user);
                              if (data !== null) {
                                updateCharacter(data.character);
                                updateFirestoreCharacter(data.character);
                                sendNewRoll(data.roll);
                              }
                            }}
                          />
                        )}
                      </div>
                      {/* <MobileView className='linkChatContainer'>
                        <Link
                          className='link'
                          to={`${match.url}/chat`}
                        >
                          <AnnotationIcon className='iconChat' />
                        </Link>
                      </MobileView> */}
                      {character.description && (
                        <div className='descriptionDetails'>
                          <p
                            className="click"
                            onClick={() => {
                              setDescriptionIsDisplay(!descriptionIsDisplay)
                            }}
                          >
                            {`${i18next.t('description')}`}
                            {descriptionIsDisplay && (
                              <ChevronUpIcon className='iconDescriptionOpen' />
                            )}
                            {!descriptionIsDisplay && (
                              <ChevronDownIcon className='iconDescriptionOpen' />
                            )}
                          </p>
                          {descriptionIsDisplay && (
                            <p
                              className="click"
                              contentEditable="true"
                              onBlur={(e)=>{
                                const updateCharacter = {...character}
                                updateCharacter.description = e.currentTarget.textContent;
                                updateFirestoreCharacter(updateCharacter);
                              }}
                            >
                              {character.description}
                            </p>
                          )}
                        </div>
                      )}
                      <div className='characteristicsDetail'>
                        <p className='titleSection'><b>{i18next.t('characteristic')}</b></p>
                          <Characteristics
                            characteristics={characteristics}
                            campaign={campaign}
                            character={character}
                            user={user}
                            hideRollSwitch={hideRollSwitch}
                            onRollStat={(stat, type) => handleSetNewDice(100, stat, type)}
                          />
                      </div>
                    </div>
                    <div className='skillsDetail'>
                      <div className='containerSkill'>
                        <div className='skillsDetail'>
                          <p className='titleSection'><b>{i18next.t('skill')}</b></p>
                          <Skills
                            skills={skills}
                            campaign={campaign}
                            character={character}
                            user={user}
                            hideRollSwitch={hideRollSwitch}
                            onRollStat={(stat, type) => handleSetNewDice(100, stat, type)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {view === 'inventory' && (
                  <div className='containerInfo containerInfoFullInv'>
                    <Inventory
                      updateInventory={(characterWithNewInventory, newRollForUpdate) => {
                        if(newRollForUpdate) {
                          sendNewRoll(newRollForUpdate);
                        }
                        updateCharacter({
                          ...characterWithNewInventory,
                        });
                        updateFirestoreCharacter(characterWithNewInventory);
                      }}
                      />
                  </div>
                )}
                {view === 'alchemy' && (
                  <div className='containerInfo'>
                    <Alchemy
                      character={character}
                      invAndReceipt={character.alchemy}
                      create={(receipt) => {
                        createPotion(receipt);
                      }}
                      updateReceipt={(receipt) => {
                        const updatedCharacter = {...character};
                        updatedCharacter.alchemy.receipt = receipt;
                        updateCharacter({...updatedCharacter})
                        updateFirestoreCharacter(updatedCharacter);
                      }}
                      use={() => {
                        const updatedCharacter = {...character};
                        updateCharacter({...updatedCharacter})
                        updateFirestoreCharacter(updatedCharacter);
                      }}
                    />  
                  </div>
                )}
                {view === 'magic' && (
                  <div className='containerInfo'>
                    <MagicCardResume
                      isEditable={campaign.playerCanUpdateCardsUsed || false}
                      cardsList={character.magicCards}
                      updateCards={(newList) => {
                        character.magicCards = newList;
                        updateCharacter({
                          ...character,
                        });
                        updateFirestoreCharacter(character);
                      }}
                    />
                  </div>
                )}
                {view === 'deathMagic' && (
                  <div className='containerInfo'>
                    <DeathMagic 
                      skill={character.skills.filter(skill => !skill.isCustom && skill.label === 'deathMagic')[0]}
                      updateValue={(val) => {
                        character.skills.find(skill => !skill.isCustom && skill.label === 'deathMagic').value = val;
                        sendNewRoll(generateUpdateHisto(character, defaultDataCharacter,campaign,user,hideRollSwitch))
                        updateCharacter({
                          ...character,
                        });
                        updateFirestoreCharacter(character);
                      }}
                      rollDice={(skill) => {
                        rollDiceDeathMagic(skill);
                      }}
                    />
                  </div>
                )}
                {view === 'imagePanel' && (
                  <div className='containerInfo'>
                    <ImagePanel
                      campaignUid={campaign.uid}
                      characterUid={character.uid}
                    />
                  </div>
                )}
                {view === 'map' && (
                  <div className='containerFullView'>
                    <CampaignMap campaignUid={campaign.uid} isDm={false} user={user} characterName={character.name} />
                  </div>
                )}
                {view === 'library' && (
                  <div className='containerFullView'>
                    <CampaignLibrary campaignUid={campaign.uid} user={user} isDm={false} />
                  </div>
                )}
                {view === 'company' && (
                  <div className='containerInfo'>
                    {company && (
                      <Company
                        company={company}
                      />  
                    )}
                  </div>
                )}
                {view === 'diceHisto' && (
                  <DiceHistorical
                    list={rollList}
                    hideRollSwitch={hideRollSwitch}
                    setHideRoll={(val) => { setHideRollSwitch(val) }}
                    onReact={handleReact}
                  />
                )}
                {!hideChat && (
                  <BrowserView className='containerHisto'>
                    <DiceHistorical
                      list={rollList}
                      hideRollSwitch={hideRollSwitch}
                      setHideRoll={(val) => { setHideRollSwitch(val) }}
                      onReact={handleReact}
                      collapsible={true}
                      hideChat={hideChat}
                      setHideChat={setHideChat}
                    />
                  </BrowserView>
                )}
                {hideChat && (
                  <BrowserView>
                    <button
                      className='showChatFab'
                      onClick={() => setHideChat(false)}
                      title={i18next.t('showChat')}
                    >
                      <ChatIcon />
                    </button>
                  </BrowserView>
                )}
                <BrowserView>
                  <DiceRoll
                    chat={false}
                    setNewDice={(valMaxRoll, qty) => handleSetNewDice(valMaxRoll, null, null, qty)}
                    animEnabled={animEnabled}
                    onToggleAnim={toggleAnim}
                    onDrawMagicCard={(quantity = 1) => {
                      const allCards = cards;
                      for (let i = 0; i < quantity; i++) {
                        const card = allCards[Math.floor(Math.random() * allCards.length)];
                        const roll = {
                          createdAt: new Date(Date.now()).toLocaleDateString("fr-FR"),
                          userName: character.name,
                          userUid: user.uid,
                          characterId: character.uid,
                          value: card.value,
                          diceType: 'Magic',
                          pictureUserSendRoll: character.picture || user.photoURL,
                          stat: { isCustom: false, label: 'worldCard', value: 0 },
                          isHided: false,
                          prefixTradStat: null,
                        };
                        sendNewRoll(roll);
                      }
                    }}
                  />
                </BrowserView>
                {/* <MobileView className='mobileInv'>
                  <Link
                    className='fullButton'
                    to={`${match.url}/inventory`}
                  >
                    <img className="iconInvLarge" src={backpack} alt="Backpack" />
                    <span>{i18next.t('inventory')}</span>
                  </Link>
                </MobileView> */}
              </div>
            )}
          </div>
        </Route>
      </Switch>
      {campaign.uid && <CampaignNotes campaignUid={campaign.uid} />}
      </>
    );

  } else {
    return null;
  }

}

export default Character